var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBacklog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1422 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6CD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    stroke: "url(#a)",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 616q355.5-716 711-216t711 216",
    strokeDasharray: "21 10",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 594q355.5-694 711-194t711 194",
    strokeDasharray: "33 6",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 572q355.5-672 711-172t711 172",
    strokeDasharray: "24 11",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 550q355.5-650 711-150t711 150",
    strokeDasharray: "15 16",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 528q355.5-628 711-128t711 128",
    strokeDasharray: "18 5",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 506q355.5-606 711-106t711 106",
    strokeDasharray: "34 24",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 484q355.5-584 711-84t711 84",
    strokeDasharray: "30 10",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 462q355.5-562 711-62t711 62",
    strokeDasharray: "32 9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 440q355.5-540 711-40t711 40",
    strokeDasharray: "28 32",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 418q355.5-518 711-18t711 18",
    strokeDasharray: "8 24",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 396q355.5-496 711 4t711-4",
    strokeDasharray: "3 28",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 374q355.5-474 711 26t711-26",
    strokeDasharray: "27 11",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 352q355.5-452 711 48t711-48",
    strokeDasharray: "27 1",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 330q355.5-430 711 70t711-70",
    strokeDasharray: "10 33",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 308q355.5-408 711 92t711-92",
    strokeDasharray: "15 24",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 286q355.5-386 711 114t711-114",
    strokeDasharray: "13 3",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 264q355.5-364 711 136t711-136",
    strokeDasharray: "33 20",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 242q355.5-342 711 158t711-158",
    strokeDasharray: "6 32",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 220q355.5-320 711 180t711-180",
    strokeDasharray: "30 1",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 198q355.5-298 711 202t711-202",
    strokeDasharray: "4 17",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 176q355.5-276 711 224t711-224",
    strokeDasharray: "17 32",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 154q355.5-254 711 246t711-246",
    strokeDasharray: "13 18",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 132q355.5-232 711 268t711-268",
    strokeDasharray: "9 21",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 110q355.5-210 711 290t711-290",
    strokeDasharray: "9 24",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 88q355.5-188 711 312t711-312",
    strokeDasharray: "5 29",
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 66q355.5-166 711 334t711-334",
    strokeDasharray: "11 26",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 44q355.5-144 711 356t711-356",
    strokeDasharray: "28 28",
    opacity: 0.96
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacklog);
export default __webpack_public_path__ + "static/media/backlog.b3664f886e5117783a4d0941f21b617a.svg";
export { ForwardRef as ReactComponent };